import { ENDPOINTS_SOLIDARITY } from 'common/endpoints/solidarity.endpoints';

export default class SolidarityDataService {

  constructor($http) {
    'ngInject';
    this.http = $http;
  }

  getOngList() {
    return this.http.get(ENDPOINTS_SOLIDARITY.get.ongList());
  }

  getContributions(employeeId) {
    return this.http.get(ENDPOINTS_SOLIDARITY.get.contributions(employeeId));
  }

  createContribution(employeeId, data) {
    const url = ENDPOINTS_SOLIDARITY.post.contributions(employeeId);
    return this.http.post(url, data);
  }

  updateContribution(employeeId, data) {
    const url = ENDPOINTS_SOLIDARITY.put.contributions(employeeId);
    return this.http.put(url, data);
  }

  deleteContribution(employeeId, data) {
    const url = ENDPOINTS_SOLIDARITY.delete.contributions(employeeId);
    const config = {
      data
    };
    return this.http.delete(url, config);
  }

}



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/services/solidarity.data.service.js